export function collapseRepeatedContent(value) {
  const content = typeof value === "string" ? value.trim() : "";
  if (content.length < 2) return content;

  // Some legacy provider responses stored the same complete answer twice in
  // one message. Find a second occurrence of the opening phrase and collapse
  // only when both halves are exactly equal, so intentional repetition stays.
  const marker = content.slice(0, Math.min(48, Math.floor(content.length / 2)));
  let repeatAt = content.indexOf(marker, 1);
  while (repeatAt > 0) {
    const first = content.slice(0, repeatAt).trim();
    const second = content.slice(repeatAt).trim();
    if (first === second) return first;
    repeatAt = content.indexOf(marker, repeatAt + 1);
  }

  return content;
}

export function normalizeTranscript(messages = []) {
  const seenAssistantContent = new Set();
  return messages.reduce((cleaned, message) => {
    const content = message?.role === "assistant"
      ? collapseRepeatedContent(message?.content)
      : typeof message?.content === "string" ? message.content.trim() : "";
    if (!content) return cleaned;
    const previous = cleaned[cleaned.length - 1];
    if (previous?.role === message.role && previous?.content === content) return cleaned;
    if (message.role !== "assistant") return [...cleaned, { ...message, content }];
    if (seenAssistantContent.has(content)) return cleaned;
    seenAssistantContent.add(content);
    return [...cleaned, { ...message, content }];
  }, []);
}
